import Table from "app/components/commonComponent/table/Table";
import { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import ProformaInvoiceTableRow from "./ProformaInvoiceTableRow";
import { searchParams } from "app/helpers/commonInterface";
import { getProformaInvoiceList } from "app/reducers/proformaInvoice/proformaInvoiceAction";
import ProformaInvoiceForm from "../ProformaInvoiceForm";
import { useGetSearchObject } from "app/helpers/customHooks";

interface props {
  proformaInvoiceDetails: any;
  proformaInvoiceListDispatch: Function;
}

const HEADERS = [
  {
    columnName: "Invoice No",
    id: "BillNumber",
    className: "min-w-125px ps-2",
  },
  {
    columnName: "Client Name",
    id: "ClientName",
    className: "min-w-125px",
  },
  {
    columnName: "Task",
    id: "NULL",
    className: "min-w-125px",
  },
  {
    columnName: "Firm",
    id: "NULL",
    className: "min-w-125px",
  },
  {
    columnName: "Total Amount",
    id: "TotalAmount",
    className: "min-w-125px",
  },
  {
    columnName: "Invoice Date",
    id: "Date",
    className: "min-w-125px",
  },
  {
    columnName: "Billing Status",
    id: "PaymentStatus",
    className: "min-w-125px",
  },
  {
    columnName: "Actions",
    id: "NULL",
    className: "min-w-125px text-end",
  },
];

const ProformaInvoiceTable: FC<props> = ({
  proformaInvoiceDetails,
  proformaInvoiceListDispatch,
}) => {
  const {searchObj} = useGetSearchObject();
  const [showBillEditForm, setShowBillEditForm] = useState<{
    show: boolean;
    billId: number | undefined;
  }>({
    show: false,
    billId: 0,
  });

  useEffect(() => {
    proformaInvoiceListDispatch(searchObj);
  }, [searchObj]);

  return (
    <>
      <Table
        checkBoxColumn={{ show: false }}
        error={proformaInvoiceDetails.error}
        headers={HEADERS}
        success={proformaInvoiceDetails.proformaInvoiceList?.success}
        loading={proformaInvoiceDetails.loading}
        paginate={{
          show: true,
          pagination: proformaInvoiceDetails.proformaInvoiceList?.pagination,
          PageNumber: Number(searchObj.PageNumber || 1),
          PageSize: Number(searchObj.PageSize) || 10,
        }}
        tableData={proformaInvoiceDetails.proformaInvoiceList?.data?.records}
        tableRow={(row: any, index: number) => (
          <ProformaInvoiceTableRow
            row={row}
            key={`row-${index}-${row.id}`}
            setShowBillEditForm={setShowBillEditForm}
          />
        )}
      />

      <ProformaInvoiceForm
        showInvoice={{
          show: showBillEditForm.show,
          billId: showBillEditForm.billId,
        }}
        closeModel={() => setShowBillEditForm({ show: false, billId: 0 })}
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    proformaInvoiceDetails: state.proformaInvoiceList,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    proformaInvoiceListDispatch: (searchObj: searchParams) =>
      dispatch(getProformaInvoiceList(searchObj)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProformaInvoiceTable);
